import { Text } from '@/components/atoms/Text';
import { Link } from '@smartproxy/decoro/v2/link';
import { ArrowRightMediumIcon } from '@smartproxy/decoro/v2/icons';

import ProductCardUseCaseIcons from './ProductCardUseCaseIcons';
import { ProductCardUseCaseProps } from './types';
import Card from '@/components/atoms/Card';

type Props = {
  useCase: ProductCardUseCaseProps;
};

export default function ProductCardUseCase({ useCase }: Props) {
  return (
    <Card
      padSize='s'
      roudnessLevel='m'
      classNames={{ root: 'flex justify-between gap-3' }}
    >
      <div className='flex flex-col gap-3'>
        <Text
          variant='body-m'
          classNames={{
            wrapper: 'dark:text-white font-serif',
          }}
        >
          {useCase.title}
        </Text>
        {useCase.icons && <ProductCardUseCaseIcons icons={useCase.icons} />}
      </div>
      {useCase.link && (
        <Link
          href={useCase.link.url}
          decoration='none'
          className='flex items-center gap-1 self-start'
          suffix={ArrowRightMediumIcon}
        >
          {useCase.link.text}
        </Link>
      )}
    </Card>
  );
}
